let lastScrollPositionSecondary = 0;

function highlightSecondaryTab(mobileOffsetValue=0, desktopOffsetValue = 0) {
  let secondarySections = document.querySelectorAll('.custom-secondary-scroll');
  let isSmallScreen = window.matchMedia('(max-width: 749px)').matches;

  const noOfTabs = document.querySelectorAll('.custom-tab');
  const navbarMargin = noOfTabs.length > 3 ? 50 + mobileOffsetValue : mobileOffsetValue;
  
  let mainMargin = isSmallScreen ? navbarMargin : 35;
  let secondaryMargin = isSmallScreen ? 10 : 40 + desktopOffsetValue; 
  let marginHeader = isSmallScreen ? 70 : 70;
  
  let scrollPosition = window.scrollY;
  let scrollingUp = scrollPosition < lastScrollPositionSecondary;
  lastScrollPositionSecondary = scrollPosition;

  if (secondarySections) {
    secondarySections.forEach(function(section) {
      let secondarySectionTop, secondarySectionBottom;
      if (scrollingUp) {
        secondarySectionTop = section.offsetTop - mainMargin - secondaryMargin - marginHeader;
        secondarySectionBottom = secondarySectionTop + section.clientHeight;
      } else {
        secondarySectionTop = section.offsetTop - mainMargin - secondaryMargin - marginHeader;
        secondarySectionBottom = secondarySectionTop + section.clientHeight;
      }
      if (scrollPosition >= secondarySectionTop && scrollPosition < secondarySectionBottom) {
          document.querySelectorAll('.custom-secondary-tab').forEach(function(tab) {
            tab.classList.remove('custom-current');
          });
          let sectionId = section.getAttribute('id');
          let tab = document.querySelector(`.custom-secondary-tab[data-section="${sectionId}"]`);
            tab.classList.add('custom-current');
      }
    });
  }
}